<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="plc || $t(`message.services`)"
    filterable
    clearable
 
  >
    <el-option v-for="item in services" :key="item.id" :label="item.name" :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import inventory from '@/utils/mixins/components/inventory';

export default {
  mixins: [inventory],
  props: ['hospitalization_service_id'],
  mounted() {
    if (this.services && this.services.length === 0) {
      this.getInventory();
    }
  },
  watch: {
    hospitalization_service_id:{
       handler: function (val, oldVal) { 
          this.selected = val;
          this.$emit("input", this.selected);
       },
       deep: true,
       immediate: true
    }
  },
  computed: {
    ...mapGetters({
      services: 'services/inventory',
    }),
  },
  methods: {
    ...mapActions({
      getInventory: 'services/inventory',
    })
  },
};
</script>
